module.exports = __webpack_public_path__ + "static/media/1012709.db059ad4.jpg";